<template>
  <v-container white>
    <v-layout row wrap justify-center>
      <v-flex xs10 headline>
        Join Code
      </v-flex>
      <v-flex xs10 ma-1>
        This enables teachers to sign up themselves using a custom school join code. Below are instructions for teachers.
      </v-flex>
      <v-flex xs8 mt-5 elevation-2 grey lighten-5 pa-3>
        <ol>
          <li>
            Go to www.brainingcamp.com
          </li>
          <li>
            Click Redeem Code
          </li>
          <li>
            Enter code <span style="font-weight: bold; text-transform: uppercase">{{joinCode}}</span>
          </li>
        </ol>
      </v-flex>
      <v-flex xs10 text-xs-center mt-3>
        <v-btn color="secondary" v-on:click="resetJoinCode">Reset Join Code</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
  
</template>

<script>
import AdministratorService from '@/services/AdministratorService'

export default {
  data: function () {
    return {
      joinCode: null
    }
  },
  mounted: async function () {
    try {
      const result = await AdministratorService.getSchool();

      this.joinCode = result.data.joinCode;
    } catch (err) {
      console.log(err)
    }
  },
  methods: {
    async resetJoinCode() {
      try {
        const result = await AdministratorService.resetJoinCode();

        this.joinCode = result.data.code;
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>

li {
  font-size: 18px;
  margin: 8px auto;
}

</style>
